/*
 * @Description:
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-03 09:35:44
 * @LastEditors: zhangle
 * @LastEditTime: 2024-01-30 17:32:06
 */
import qs from 'qs'
/**
 * 请求统一管理
 */
import Request from '@/common/copyright/request';
/* Common */
// export const apiMe = () => Request.get('api/me'); // 登录状态查询接口
export const apiMe = () => Request.get('drama/api/me?hidden=true'); // 登录状态查询接口
export const getUserPermission = () => Request.get(`drama/api/opusUserInfo/user`);//获取用户权限
// 查询分类列表
export const apiDramaCategorySearchList = (data) => Request.post('drama/api/dramaCategory/search/list', data); // 查询剧集分类列表

//查询当前剩余次数
export const findBalanceApi = (number) => Request.get(`/drama/api/order/balance/${number}`);

export const logout = () => Request.post('drama/api/logout');

// 获取账号和子账号
export const getAccountListApi = (isAll=true) => Request.get('drama/api/account?isAll=' + isAll);


//证据生成分享
export const shareCreate = (params) => Request.post('drama/api/share/create', params, {
    customCode: 'system'
});

//查询证据分享
export const shareSearch = (params) => Request.get('drama/api/share/search', params, {
    customCode: 'system'
});

//停止证据分享
export const shareStop = (params) => Request.put('drama/api/share/stop', params, {
    customCode: 'system'
});

// 校验opus文件是否存在
export const validateOpusDetailApi = (data) => Request.post('drama/api/opus/validate', data, {
    customCode: 'system'
})

// 通用下载
export const downloadOpusApi = (data) => Request.post('drama/api/opus/download', data,)

// 以保护文件列表
export const opusListApi = (data) => Request.post('api/opus', qs.stringify(data))